import locales from "../locales";
import {Role} from "../account/AccountProvider";
import {OptionProps} from "antd/lib/select";

export const userRoleToText = {
  [Role.ADMIN]: locales.user_admin,
  [Role.SALES]: locales.user_sales,
  [Role.MAINTENANCE]: locales.user_maintenance,
};

export function getUserRoleOptions(): OptionProps[] {
  return [Role.ADMIN, Role.SALES, Role.MAINTENANCE]
    .map(type => ({value: type, key: type, title: userRoleToText[type]}));
}


// WEBPACK FOOTER //
// ./src/user-management/dto.tsx